import { driver } from "driver.js";

export const setDriverConsegnaPinForm = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna un pacco al cliente', description: 'Controlla il pin, ricerca e scansiona il codice a barre del pacco e consegnalo.', popoverClass: 'title-popover-class' } },
      { element: '#inserisciScansiona', popover: { title: 'Inserisci o Scansiona', description: 'Digita il pin o usa lo scan per identificare il pacco e procedere alla consegna. Il pin è un codice alfanumerico di 6 cifre.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConferma', popover: { title: 'Conferma e Procedi', description: 'Se tutti i dati sono corretti, PuntoPoste ti fornirà i dati del pacco in consegna.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConsegnaSenzaPin', popover: { title: 'Consegna senza Pin', description: 'Se il cliente non ha ricevuto il PIN potrà comunque effettuare la consegna', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}


export const setDriverConsegnaNoPinForm = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna un pacco al cliente', description: 'Controlla il pin, ricerca e scansiona il codice a barre del pacco e consegnalo.', popoverClass: 'title-popover-class' }},
      { element: '#inserisciScansionaPacco', popover: { title: 'Inserisci o scansiona', description: 'Digita il codice o usa lo scan per verificare il pacco. Trovi il codice alfanumerico di 13 caratteri sulla lettera di vettura.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConferma', popover: { title: 'Conferma e Procedi', description: 'Se tutti i dati sono corretti, PuntoPoste ti fornirà i dati del pacco in consegna.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverConsegnaFormDataPin = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna un pacco al cliente', description: 'Controlla il pin, ricerca e scansiona il codice a barre del pacco e consegnalo.', popoverClass: 'title-popover-class' }},
      { element: '#buttonSmarrito', popover: { title: 'Se non trovi il pacco in magazzino', description: 'Assegna lo stato di "smarrito" al pacco in lavorazione', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonRifiuta', popover: { title: 'Se il cliente non vuole il pacco', description: 'Assegna lo stato di “rifiutato” al pacco in lavorazione.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConsegna', popover: { title: 'Operazione Completata', description: 'Ora puoi consegnare il pacco.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverConsegnaFormDataNoPin = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna un pacco al cliente', description: 'Controlla il pin, ricerca e scansiona il codice a barre del pacco e consegnalo.', popoverClass: 'title-popover-class' }},
      { element: '#buttonRifiuta', popover: { title: 'Se il cliente non vuole il pacco', description: 'Assegna lo stato di “rifiutato” al pacco in lavorazione.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConsegna', popover: { title: 'Operazione Completata', description: 'Ora puoi consegnare il pacco.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverVenditaFormCodice = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Vendi un pacco al cliente', description: 'Scansione o inserisci il codice e conferma', side: "right", align: 'start', popoverClass: 'title-popover-class' }},
      { element: '#inserisciScansionaPacco', popover: { title: 'Inserisci o scansiona', description: 'Utilizza il lettore ottico o digita qui il codice per identificare il pacco e procedere alla vendita', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConferma', popover: { title: 'Conferma e procedi', description: 'Se il codice è corretto il sistema ti fornirà i dati del pacco da vendere', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverVenditaDettaglio = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
    { popover: { title: 'Vendi un pacco al cliente', description: 'Scansione o inserisci il codice e conferma', side: "right", align: 'start', popoverClass: 'title-popover-class' }},
    { element: '#buttonVendi', popover: { title: 'Procedi alla vendita del pacco', description: 'Il sistema verificherà se il pacco è vendibile e ne mostrerà il prezzo. Dovrai marcare il flag di emissione scontrino per poter confermare la vendita', side: "top", align: 'start', popoverClass: 'title-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverAccettazioneFormCodice = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Accetta un pacco dal cliente', description: 'Scansiona o inserisci il codice, conferma e completa i dati e accetta il pacco.', popoverClass: 'title-popover-class' }},
      { element: '#inserisciScansiona', popover: { title: 'Inserisci o scansiona', description: 'Digita qui il codice o usa lo scan per identificare il pacco e procedere all’accettazione', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonConferma', popover: { title: 'Conferma e Procedi', description: 'Se tutti i dati sono corretti, PuntoPoste ti fornirà i dati del pacco in accettazione.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverAccettazioneDettaglio = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Accetta un pacco dal cliente', description: 'Scansiona o inserisci il codice, conferma e completa i dati e accetta il pacco.', popoverClass: 'title-popover-class' }},
      { element: '#formDati', popover: { title: 'Conferma e Completa', description: 'E’ obbligatorio inserire l’indirizzo email o il numero telefonico del cliente per poter accettare il pacco e fornire la ricevuta elettronica', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#buttonAccetta', popover: { title: 'Accettazione completata', description: 'Se tutti i dati sono stati inseriti correttamente puoi accettare il pacco.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverAccettazioneInfo = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Accetta un pacco dal cliente', description: 'Scansiona o inserisci il codice, conferma e completa i dati e accetta il pacco.', popoverClass: 'title-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverConsegnaCorriereDettaglioConPalmare = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna al corriere i tuoi pacchi', description: 'Verifica i pacchi in uscita, crea la bolla e consegna al corriere.', popoverClass: 'title-popover-class' }},
      { element: '#procediCrea', popover: { title: 'Procedi e crea la bolla', description: 'Crea la bolla contenente tutti i pacchi etichettati come "pronto per la spedizione" (icona verde).', side: "top", align: 'center', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverConsegnaCorriereDettaglioInitialStep = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Consegna al corriere i tuoi pacchi', description: 'Verifica i pacchi in uscita, crea la bolla e consegna al corriere.', popoverClass: 'title-popover-class' }},
      { element: '#verificaPacco', popover: { title: 'Verifica il pacco e conferma lo stato della spedizione', description: 'I pacchi con icona verde sono pronti per essere consegnati ed andranno nella bolla corrente. Quelli con icona arancio rimarranno in lista fino a domani per poi passare allo stato di "smarrito" se non dovessi verificarli. Assegna lo stato di "furgone pieno" ad un pacco se il corriere non può prenderlo in carico.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#salvaBozza', popover: { title: 'Salva i pacchi già verificati', description: 'Perderai il lavoro salvato se nel frattempo accetterai nuovi pacchi o un cliente rifiuterà la consegna.', side: "top", align: 'center', popoverClass: 'description-popover-class' }},
      { element: '#procediCrea', popover: { title: 'Procedi e crea la bolla', description: 'Crea la bolla contenente tutti i pacchi etichettati come "pronto per la spedizione" (icona verde).', side: "top", align: 'center', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverAccettazioneCorriere = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Accetta i pacchi dal corriere', description: 'Scansiona o inserisci il codice, verifica ed accetta i pacchi.', popoverClass: 'title-popover-class' }},
      { element: '#inserisciScansiona', popover: { title: 'Inserisci o scansiona', description: 'Digita qui il codice o usa lo scan per identificare i pacchi e procedere all’accettazione. Puoi accettare un singolo pacco o una distinta.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#confermaProcedi', popover: { title: 'Conferma e Procedi', description: 'Se tutti i dati sono corretti, PuntoPoste elencher&agrave; i dettagli di tutti i pacchi da verificare singolarmente.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}

export const setDriverAccettazioneCorriereDettaglio = (): void => {
  const driverObj = driver({
    showProgress: false,
    nextBtnText: 'Successivo',
    prevBtnText: 'Precedente',
    doneBtnText: 'Chiudi',
    steps: [
      { popover: { title: 'Accetta i pacchi dal corriere', description: 'Scansiona o inserisci il codice, verifica ed accetta i pacchi.', popoverClass: 'title-popover-class' }},
      { element: '#inserisciScansionaLdv', popover: { title: 'Inserisci o scansiona', description: 'Digita il codice o usa lo scan per verificare un pacco. Trovi il codice alfanumerico di 13 caratteri sulla lettera di vettura.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#verificaPacco', popover: { title: 'Verifica il pacco e conferma lo stato della spedizione', description: 'Scansiona singolarmente i codici dei pacchi da ritirare. Verifica i pacchi con icona arancione: per procedere scansiona i codici se vuoi ritirarli oppure attribuisci lo stato “Rifiutato”, "Ufficio saturo”, “Disguidato” o “Smarrito” senza ritirare i pacchi. In caso di dubbi contatta l’assistenza.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
      { element: '#operazioneCompletata', popover: { title: 'Operazione Completata', description: 'I pacchi "disponibili alla consegna" saranno accettati all\'interno del tuo magazzino.', side: "right", align: 'start', popoverClass: 'description-popover-class' }},
    ]
  });
  driverObj.drive();
}
